import React from "react";
import { NavLink } from "react-router-dom";
import Switcher from "../Elements/Switcher";

var bgimage = require("./../../images/background/bg-site.png");

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.currentstate = { logo: require("./../../images/logo-bg-dark.png") };
  }

  updateFooterLogo = updatedlogo => {
    this.currentstate.logo = updatedlogo;
  };

  render() {
    return (
      <>
        {/* Newsletter Section */}
        <div
          className="newsletter-section"
          style={{ backgroundColor: "rgb(63, 164, 202)", padding: "20px 0" }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 text-center text-lg-left m-b30">
                <h3
                  style={{
                    color: "#fff",
                    fontSize: "28px",
                    fontWeight: "600",
                    marginBottom: "10px",
                  }}
                >
                  Partner With Us
                </h3>
                <p
                  style={{
                    color: "rgba(255,255,255,0.9)",
                    fontSize: "16px",
                    margin: 0,
                  }}
                >
                  From supply to execution, we make construction simple,
                  reliable, and scalable.
                </p>
              </div>
              <div className="col-lg-6 col-md-12 ">
                <div
                  className="newsletter-form"
                  style={{
                    maxWidth: "400px",
                    margin: "0 auto ",
                    marginTop: "50px",
                  }}
                >
                  <form
                    role="search"
                    action="./"
                    style={{ display: "flex", gap: "10px" }}
                  >
                    <input
                      name="news-letter"
                      className="form-control"
                      placeholder="Enter your email address"
                      type="email"
                      style={{
                        flex: "1",
                        padding: "15px 20px",
                        fontSize: "16px",
                        border: "none",
                        borderRadius: "50px",
                        outline: "none",
                      }}
                    />
                    <button
                      type="submit"
                      style={{
                        backgroundColor: "#fff",
                        color: "rgb(63, 164, 202)",
                        border: "none",
                        borderRadius: "50px",
                        fontSize: "16px",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        whiteSpace: "nowrap",
                      }}
                      onMouseEnter={e => {
                        e.target.style.backgroundColor = "#f8f9fa";
                        e.target.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={e => {
                        e.target.style.backgroundColor = "#fff";
                        e.target.style.transform = "translateY(0)";
                      }}
                    >
                      <i
                        className="fa fa-paper-plane-o"
                        style={{ padding: "5px" }}
                      ></i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer
          className="site-footer footer-large footer-dark footer-wide"
          style={{ backgroundColor: "#1a1a1a" }}
        >
          {/* Main Footer Content */}
          <div className="footer-top" style={{ padding: "60px 0 40px" }}>
            <div className="container">
              <div className="row">
                {/* Company Info */}
                <div className="col-lg-4 col-md-6 col-sm-12 m-b40">
                  <div className="widget widget_about">
                    <div className="logo-footer clearfix m-b20">
                      <NavLink to={"./"}>
                        <img
                          src={this.currentstate.logo}
                          alt="BuildInfra Logo"
                          style={{
                            maxHeight: "50px",
                            filter: "brightness(1.2)",
                          }}
                        />
                      </NavLink>
                    </div>
                    <h4
                      className="widget-title"
                      style={{
                        color: "#fff",
                        fontSize: "20px",
                        marginBottom: "15px",
                      }}
                    >
                      About BuildInfra
                    </h4>
                    <p
                      style={{
                        color: "#b0b0b0",
                        fontSize: "15px",
                        lineHeight: "1.7",
                        marginBottom: "25px",
                      }}
                    >
                      Leading supplier of B2B premium construction materials in
                      India. We deliver quality, innovation, and reliability to
                      build the future of infrastructure.
                    </p>

                    {/* Social Media Links */}
                    <div className="social-section">
                      <h5
                        style={{
                          color: "#fff",
                          fontSize: "16px",
                          marginBottom: "15px",
                        }}
                      >
                        Follow Us
                      </h5>
                      <ul
                        className="social-icons"
                        style={{
                          display: "flex",
                          gap: "15px",
                          listStyle: "none",
                          padding: 0,
                        }}
                      >
                        <li>
                          <span
                            className="social-link facebook"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "45px",
                              height: "45px",
                              backgroundColor: "#3b5998", // Facebook blue
                              borderRadius: "50%",
                              color: "#fff",
                              fontSize: "18px",
                              transition: "all 0.3s ease",
                              textDecoration: "none",
                              cursor: "not-allowed",
                              pointerEvents: "none",
                            }}
                          >
                            <i className="fa fa-facebook" />
                          </span>
                        </li>
                        <li>
                          <span
                            className="social-link twitter"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "45px",
                              height: "45px",
                              backgroundColor: "#1da1f2", // Twitter blue
                              borderRadius: "50%",
                              color: "#fff",
                              fontSize: "18px",
                              transition: "all 0.3s ease",
                              textDecoration: "none",
                              cursor: "not-allowed",
                              pointerEvents: "none",
                            }}
                          >
                            <i className="fa fa-twitter" />
                          </span>
                        </li>
                        <li>
                          <span
                            className="social-link linkedin"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "45px",
                              height: "45px",
                              backgroundColor: "#0077b5", // LinkedIn blue
                              borderRadius: "50%",
                              color: "#fff",
                              fontSize: "18px",
                              transition: "all 0.3s ease",
                              textDecoration: "none",
                              cursor: "not-allowed",
                              pointerEvents: "none",
                            }}
                          >
                            <i className="fa fa-linkedin" />
                          </span>
                        </li>
                        <li>
                          <span
                            className="social-link instagram"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "45px",
                              height: "45px",
                              background:
                                "radial-gradient(circle at 30% 110%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)", // Instagram gradient
                              borderRadius: "50%",
                              color: "#fff",
                              fontSize: "18px",
                              transition: "all 0.3s ease",
                              textDecoration: "none",
                              cursor: "not-allowed",
                              pointerEvents: "none",
                            }}
                          >
                            <i className="fa fa-instagram" />
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Quick Links */}
                <div className="col-lg-2 col-md-6 col-sm-6 m-b40">
                  <div className="widget widget_services">
                    <h4
                      className="widget-title"
                      style={{
                        color: "#fff",
                        fontSize: "18px",
                        marginBottom: "25px",
                        position: "relative",
                        paddingBottom: "10px",
                      }}
                    >
                      Quick Links
                      <span
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          width: "30px",
                          height: "2px",
                          backgroundColor: "rgb(63, 164, 202)",
                        }}
                      ></span>
                    </h4>
                    <ul style={{ listStyle: "none", padding: 0 }}>
                      <li style={{ marginBottom: "12px" }}>
                        <NavLink
                          to={"/about"}
                          style={{
                            color: "#b0b0b0",
                            textDecoration: "none",
                            fontSize: "15px",
                            transition: "color 0.3s ease",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onMouseEnter={e =>
                            (e.target.style.color = "rgb(63, 164, 202)")
                          }
                          onMouseLeave={e => (e.target.style.color = "#b0b0b0")}
                        >
                          <i
                            className="fa fa-angle-right"
                            style={{ marginRight: "8px", fontSize: "12px" }}
                          ></i>
                          About Us
                        </NavLink>
                      </li>
                      <li style={{ marginBottom: "12px" }}>
                        <NavLink
                          to={"/services"}
                          style={{
                            color: "#b0b0b0",
                            textDecoration: "none",
                            fontSize: "15px",
                            transition: "color 0.3s ease",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onMouseEnter={e =>
                            (e.target.style.color = "rgb(63, 164, 202)")
                          }
                          onMouseLeave={e => (e.target.style.color = "#b0b0b0")}
                        >
                          <i
                            className="fa fa-angle-right"
                            style={{ marginRight: "8px", fontSize: "12px" }}
                          ></i>
                          Products
                        </NavLink>
                      </li>
                      <li style={{ marginBottom: "12px" }}>
                        <NavLink
                          to={"/project-grid"}
                          style={{
                            color: "#b0b0b0",
                            textDecoration: "none",
                            fontSize: "15px",
                            transition: "color 0.3s ease",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onMouseEnter={e =>
                            (e.target.style.color = "rgb(63, 164, 202)")
                          }
                          onMouseLeave={e => (e.target.style.color = "#b0b0b0")}
                        >
                          <i
                            className="fa fa-angle-right"
                            style={{ marginRight: "8px", fontSize: "12px" }}
                          ></i>
                          Projects
                        </NavLink>
                      </li>
                      {/* <li style={{ marginBottom: "12px" }}>
                        <NavLink
                          to={"/blog-grid"}
                          style={{
                            color: "#b0b0b0",
                            textDecoration: "none",
                            fontSize: "15px",
                            transition: "color 0.3s ease",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onMouseEnter={e =>
                            (e.target.style.color = "rgb(63, 164, 202)")
                          }
                          onMouseLeave={e => (e.target.style.color = "#b0b0b0")}
                        >
                          <i
                            className="fa fa-angle-right"
                            style={{ marginRight: "8px", fontSize: "12px" }}
                          ></i>
                          Blog
                        </NavLink>
                      </li> */}
                      <li style={{ marginBottom: "12px" }}>
                        <NavLink
                          to={"/contactus"}
                          style={{
                            color: "#b0b0b0",
                            textDecoration: "none",
                            fontSize: "15px",
                            transition: "color 0.3s ease",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onMouseEnter={e =>
                            (e.target.style.color = "rgb(63, 164, 202)")
                          }
                          onMouseLeave={e => (e.target.style.color = "#b0b0b0")}
                        >
                          <i
                            className="fa fa-angle-right"
                            style={{ marginRight: "8px", fontSize: "12px" }}
                          ></i>
                          Contact Us
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Services */}
                <div className="col-lg-3 col-md-6 col-sm-6 m-b40">
                  <div className="widget widget_services">
                    <h4
                      className="widget-title"
                      style={{
                        color: "#fff",
                        fontSize: "18px",
                        marginBottom: "25px",
                        position: "relative",
                        paddingBottom: "10px",
                      }}
                    >
                      Our Services
                      <span
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          width: "30px",
                          height: "2px",
                          backgroundColor: "rgb(63, 164, 202)",
                        }}
                      ></span>
                    </h4>
                    <ul style={{ listStyle: "none", padding: 0 }}>
                      <li style={{ marginBottom: "12px" }}>
                        <span
                          style={{
                            color: "#b0b0b0",
                            textDecoration: "none",
                            fontSize: "15px",
                            display: "flex",
                            alignItems: "center",
                            cursor: "not-allowed",
                            pointerEvents: "none",
                          }}
                        >
                          <i
                            className="fa fa-angle-right"
                            style={{ marginRight: "8px", fontSize: "12px" }}
                          ></i>
                          Construction Materials
                        </span>
                      </li>
                      <li style={{ marginBottom: "12px" }}>
                        <span
                          style={{
                            color: "#b0b0b0",
                            textDecoration: "none",
                            fontSize: "15px",
                            display: "flex",
                            alignItems: "center",
                            cursor: "not-allowed",
                            pointerEvents: "none",
                          }}
                        >
                          <i
                            className="fa fa-angle-right"
                            style={{ marginRight: "8px", fontSize: "12px" }}
                          ></i>
                          Quality Assurance
                        </span>
                      </li>
                      <li style={{ marginBottom: "12px" }}>
                        <span
                          style={{
                            color: "#b0b0b0",
                            textDecoration: "none",
                            fontSize: "15px",
                            display: "flex",
                            alignItems: "center",
                            cursor: "not-allowed",
                            pointerEvents: "none",
                          }}
                        >
                          <i
                            className="fa fa-angle-right"
                            style={{ marginRight: "8px", fontSize: "12px" }}
                          ></i>
                          Logistics Support
                        </span>
                      </li>
                      <li style={{ marginBottom: "12px" }}>
                        <span
                          style={{
                            color: "#b0b0b0",
                            textDecoration: "none",
                            fontSize: "15px",
                            display: "flex",
                            alignItems: "center",
                            cursor: "not-allowed",
                            pointerEvents: "none",
                          }}
                        >
                          <i
                            className="fa fa-angle-right"
                            style={{ marginRight: "8px", fontSize: "12px" }}
                          ></i>
                          Project Consultation
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Contact Info */}
                <div className="col-lg-3 col-md-6 col-sm-12 m-b40">
                  <div className="widget widget_address_outer">
                    <h4
                      className="widget-title"
                      style={{
                        color: "#fff",
                        fontSize: "18px",
                        marginBottom: "25px",
                        position: "relative",
                        paddingBottom: "10px",
                      }}
                    >
                      Get In Touch
                      <span
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          width: "30px",
                          height: "2px",
                          backgroundColor: "rgb(63, 164, 202)",
                        }}
                      ></span>
                    </h4>
                    <div className="contact-info">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginBottom: "20px",
                          padding: "15px",
                          backgroundColor: "rgba(255,255,255,0.05)",
                          borderRadius: "8px",
                          border: "1px solid rgba(255,255,255,0.1)",
                        }}
                      >
                        <i
                          className="fa fa-map-marker"
                          style={{
                            color: "rgb(63, 164, 202)",
                            fontSize: "18px",
                            marginRight: "15px",
                            marginTop: "3px",
                          }}
                        ></i>
                        <div>
                          <h6
                            style={{
                              color: "#fff",
                              fontSize: "14px",
                              margin: "0 0 5px 0",
                              fontWeight: "600",
                            }}
                          >
                            Head Office
                          </h6>
                          <p
                            style={{
                              color: "#b0b0b0",
                              fontSize: "14px",
                              margin: 0,
                              lineHeight: "1.5",
                            }}
                          >
                            Jaipur, Rajasthan
                            <br />
                            India
                          </p>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginBottom: "20px",
                          padding: "15px",
                          backgroundColor: "rgba(255,255,255,0.05)",
                          borderRadius: "8px",
                          border: "1px solid rgba(255,255,255,0.1)",
                        }}
                      >
                        <i
                          className="fa fa-envelope"
                          style={{
                            color: "rgb(63, 164, 202)",
                            fontSize: "16px",
                            marginRight: "15px",
                            marginTop: "3px",
                          }}
                        ></i>
                        <div>
                          <h6
                            style={{
                              color: "#fff",
                              fontSize: "14px",
                              margin: "0 0 5px 0",
                              fontWeight: "600",
                            }}
                          >
                            Email
                          </h6>
                          <a
                            href="mailto:info@builinfra.ai"
                            style={{
                              color: "#b0b0b0",
                              textDecoration: "none",
                              fontSize: "14px",
                              transition: "color 0.3s ease",
                            }}
                            onMouseEnter={e =>
                              (e.target.style.color = "rgb(63, 164, 202)")
                            }
                            onMouseLeave={e =>
                              (e.target.style.color = "#b0b0b0")
                            }
                          >
                            info@buildinfra.ai
                          </a>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginBottom: "20px",
                          padding: "15px",
                          backgroundColor: "rgba(255,255,255,0.05)",
                          borderRadius: "8px",
                          border: "1px solid rgba(255,255,255,0.1)",
                        }}
                      >
                        <i
                          className="fa fa-phone"
                          style={{
                            color: "rgb(63, 164, 202)",
                            fontSize: "16px",
                            marginRight: "15px",
                            marginTop: "3px",
                          }}
                        ></i>
                        <div>
                          <h6
                            style={{
                              color: "#fff",
                              fontSize: "14px",
                              margin: "0 0 5px 0",
                              fontWeight: "600",
                            }}
                          >
                            Phone
                          </h6>
                          <a
                            href="tel:+919983049040"
                            style={{
                              color: "#b0b0b0",
                              textDecoration: "none",
                              fontSize: "14px",
                              display: "block",
                              marginBottom: "5px",
                              transition: "color 0.3s ease",
                            }}
                            onMouseEnter={e =>
                              (e.target.style.color = "rgb(63, 164, 202)")
                            }
                            onMouseLeave={e =>
                              (e.target.style.color = "#b0b0b0")
                            }
                          >
                            (+91) 9983049040
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div
            className="footer-bottom"
            style={{
              backgroundColor: "#111",
              borderTop: "1px solid rgba(255,255,255,0.1)",
              padding: "25px 0",
            }}
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6 text-center text-md-left">
                  <span style={{ color: "#b0b0b0", fontSize: "14px" }}>
                    © {new Date().getFullYear()} BuildInfra. All rights
                    reserved. Designed By{" "}
                    <a
                      href="https://ravviolabs.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "rgb(63, 164, 202)",
                        textDecoration: "none",
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={e => (e.target.style.color = "#fff")}
                      onMouseLeave={e =>
                        (e.target.style.color = "rgb(63, 164, 202)")
                      }
                    >
                      Ravviolabs
                    </a>
                  </span>
                </div>
                <div className="col-md-6 text-center text-md-right">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      justifyContent: "flex-end",
                      gap: "25px",
                      flexWrap: "wrap",
                    }}
                  >
                    <a
                      href="#"
                      style={{
                        color: "#b0b0b0",
                        textDecoration: "none",
                        fontSize: "14px",
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={e =>
                        (e.target.style.color = "rgb(63, 164, 202)")
                      }
                      onMouseLeave={e => (e.target.style.color = "#b0b0b0")}
                    >
                      Privacy Policy
                    </a>
                    <a
                      href="#"
                      style={{
                        color: "#b0b0b0",
                        textDecoration: "none",
                        fontSize: "14px",
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={e =>
                        (e.target.style.color = "rgb(63, 164, 202)")
                      }
                      onMouseLeave={e => (e.target.style.color = "#b0b0b0")}
                    >
                      Terms of Service
                    </a>
                    <a
                      href="#"
                      style={{
                        color: "#b0b0b0",
                        textDecoration: "none",
                        fontSize: "14px",
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={e =>
                        (e.target.style.color = "rgb(63, 164, 202)")
                      }
                      onMouseLeave={e => (e.target.style.color = "#b0b0b0")}
                    >
                      Sitemap
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <Switcher updateFooterLogo={this.updateFooterLogo.bind(this)} />

        {/* Responsive Styles */}
        <style jsx>{`
          @media (max-width: 991px) {
            .newsletter-form form {
              flex-direction: column !important;
              gap: 15px !important;
            }
            .newsletter-form button {
              width: 100% !important;
            }
          }

          @media (max-width: 767px) {
            .newsletter-section {
              padding: 40px 0 !important;
            }
            .newsletter-section h3 {
              font-size: 24px !important;
            }
            .footer-top {
              padding: 40px 0 20px !important;
            }
            .back-to-top {
              bottom: 20px !important;
              right: 20px !important;
              width: 45px !important;
              height: 45px !important;
            }
            .footer-bottom div[style*="flex-end"] {
              justify-content: center !important;
              margin-top: 15px;
            }
          }

          @media (max-width: 576px) {
            .contact-info > div {
              flex-direction: column !important;
              text-align: center !important;
            }
            .contact-info i {
              margin: 0 0 10px 0 !important;
            }
          }
        `}</style>
      </>
    );
  }
}

export default Footer;
